module.exports = __webpack_public_path__ + "img/start-location.f9fe72e5.svg";